import styled from 'styled-components'

const EntityInnerItemsControlsUi = styled.div`
  display: flex;
  flex-direction: column;
`

export default EntityInnerItemsControlsUi
